<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
    <div class="gc-login-container vx-col QQsm:w-1/2 QQmd:w-1/2 QQlg:w-3/4 QQxl:w-3/5 QQsm:m-0 m-4">
      <vx-card class="gc-login-card no-bg">
        <div slot="no-body" class="full-page-bg-color">

          <div class="vx-row no-gutter xxjustify-center justify-end items-center">

<!--            <div class="vx-col hidden lg:block lg:w-1/2">-->
<!--              <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">-->
<!--            </div>-->

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg gc-login-form">
              <div class="px-8 pt-8 xlogin-tabs-container">

<!--                  <div class="head-bg-img">-->
<!--                      <img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">-->
<!--                  </div>-->

                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">Yooz</h4>
<!--                  <p>欢迎登录</p>-->
                </div>

                <div class="vx-card__title mb-4" style="margin-top:40px;">


                    <div>
                        <form>




                        <vx-input-group class="mb-base" >

                            <gc-cmp-vs-input
                                    v-validate="'required|numeric|min:11|max:11'"
                                    data-vv-validate-on="blur"
                                    xtype="number"
                                    id="email"
                                    name="email"
                                    max-length="11"
                                    maxlength="11"
                                    icon-no-border
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="手机"
                                    autocomplete="on"
                                    v-model="phone"
                                    class="w-full"/>
                            <span class="text-danger text-sm">{{ errors.first('phone') }}</span>
                        </vx-input-group>



                        <!-- Append Button -->
                        <vx-input-group class="mb-base" >
                            <gc-cmp-vs-input type="number" placeholder="验证码" maxlength="4" autocomplete="off"
                                             id="el_verify_code" @input="limitVerifyCode" v-model="code" />

                            <template slot="append">
                                <div class="append-text btn-addon">
                                    <gc-cmp-vs-verify-button color="warning" :parameters="verifyParam"
                                                             v-on:sms-sent="smsSent"
                                    >发送验证码</gc-cmp-vs-verify-button>
                                </div>
                            </template>
                        </vx-input-group>
                        <!-- /Append Button -->


                        <vx-input-group class="mb-base" >

                            <gc-cmp-vs-input
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:6|max:18'"
                                    type="password"
                                    name="password"
                                    icon-no-border
                                    icon="icon icon-lock"
                                    icon-pack="feather"
                                    label-placeholder="登录密码"
                                    v-model="password"
                                    class="w-full xxmt-12" />
                            <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                        </vx-input-group>


                        <vx-input-group class="mb-base" >

                            <gc-cmp-vs-input
                                    v-validate="'required|min:2|max:10'"
                                    data-vv-validate-on="blur"
                                    xtype="number"
                                    name="name"
                                    max-length="11"
                                    maxlength="10"
                                    icon-no-border
                                    icon="icon icon-user"
                                    icon-pack="feather"
                                    label-placeholder="姓名"
                                    v-model="name"
                                    class="w-full"/>
                            <span class="text-danger text-sm">{{ errors.first('姓名') }}</span>
                        </vx-input-group>


                        <div class="flex flex-wrap justify-between mb-3 my-8 mt-12">
                            <vs-button type="border" @click="goHome">登录</vs-button>

                            <gc-cmp-vs-submit-button class="" :condition="validate" :parameters="saveParam" uri="staff-account/registerDriver"
                                 v-on:respond-success="savedOK" v-on:respond-fail="saveFail">注册</gc-cmp-vs-submit-button>
                        </div>


                        </form>
                    </div>


                </div>

                <div class="justify-center items-center vx-card__title mb-4 bottom-logo" >
                </div>

              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>


<script>
// import LoginJwt from './LoginJWT.vue'
// import LoginFirebase from './LoginFirebase.vue'
// import LoginAuth0 from './LoginAuth0.vue'

import {Session} from "../../../h5_src/framework/Session";
import GcCmpVsInput from "../../../group-cloud/components/vsInput";
import GcCmpVsVerifyButton from "../../../group-cloud/components/vsButton.verify";
import GcCmpVsSubmitButton from "../../../group-cloud/components/vsButton.submit";
import {GC_Validator} from "../../../group-cloud/components/validator/Validator";

export default {
  components: {
      GcCmpVsSubmitButton,
      GcCmpVsVerifyButton,
      GcCmpVsInput
    // LoginFirebase,
    // LoginAuth0
  },
    data() {
        return {
            phone: '',
            code: '',
            name: '',
            password: '',
        }
    },
    computed: {
        validateForm () {
            return !this.errors.any() && this.phone !== '' && this.password !== ''
        },
        isRegister() {
            return  'register' === this.type;
        },
        verifyParam() {
            return {
                mobile: this.phone,
                type: 'register',
            };
        },
        saveParam() {
            return  {
                name: this.name,
                phone: this.phone,
                password: this.password,
                code: this.code
            }
        },
        activeUserInfo() {
            return Session;
        },
        verifyDesc() {
            return  `手机号码：${Session.getMobile()}`;
        }
    },
    methods: {
        goLogin() {
            this.$router.push('/pages/login').catch(() => {})
        },
        goHome() {
            this.$router.push('/').catch(() => {})
        },
        validate() {
            let conf = {
                phone:   [
                    ['RegExp', ['^1[0-9]{10}$'], '请输入有效的手机号'],     // AND
                ],
                code:   [
                    ['RegExp', ['^[0-9]{4}$'], '验证码应为4位数字'],     // AND
                ],
                password:  [
                    // ['String', {'exact': ''}],
                    ['Password', {'min': 6, 'max': 18}, '密码应为6-18个字符'],
                ],
                name:   [
                    ['String', {'min': 2, 'max': 10, 'mb': 1}, '姓名应为2-10个字符'],
                ],
            };  // conf
            let validator = new GC_Validator(this, this.saveParam, conf);
            return  validator.validate(this.onErrorFocus);
            // return  true;
        },
        limitVerifyCode(evt) {
            // console.log(['limit', this.verify_code]);
            if (this.code.length > 4) {
                this.code = this.code.substring(0, 4);
            }
            this.code = this.filterNonNumber(this.code);
            // return  false;
        },
        filterNonNumber(str) {
            let idx = 0, regex, char;
            str = '' + str;
            let ret = '';
            for (idx = 0; idx < str.length; idx++) {
                regex   = new RegExp('[0-9]');
                char    = str.substring(idx, idx + 1);
                // console.log([idx, char]);
                if (regex.test(char)) {
                    ret += char;
                }
            }
            // console.log(['filter', ret]);
            return  ret;
        },
        smsSent() {
            this.$notifySuccess('验证码已发送');
            this.focusCode();
        },
        focusCode() {
            let el_code = this.$el.querySelector('#el_verify_code');
            if (el_code && el_code.focus) { el_code.focus(); }
        },
        mobileCheckInvalid() {
            this.focusMobile();
        },
        saveFail(error) {
            this.$notifyError(error);
        },
        savedOK(resp) {
            if (!resp) { return; }
            if (resp.succ) {
                this.$notifySuccess('注册成功并已登录');
                this.code = '';
                this.password = '';
                this.name = '';
                this.phone = '';
                // this.goHome();
                Session.loginSuccess({}, resp);

            } else {
                this.$notifyError(resp.error);
            }
        },
        doRegister() {

        }
    },
    mounted() {
        // console.log(['login-mounted', this.type]);
    },
    created() {
      // console.log(this.$route);
      //   this.type = this.$route.query.type || '';
    }

}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.bottom-logo {
  // position: absolute;

  // bottom: 0;

  display: flex;
  align-items: center;
  color: rgba(52,147,228,1);

  /*margin-top: 100px;*/
  // border:1px solid red;
  text-align: center;
  // width: 100px;
  // margin: 0 auto;
  // display: block;

  img {
    width: 30px;
    margin-right: 4px;
  }
}
/*@media (min-width: 1200px) {*/
/*    .gc-login-container {*/
/*        width: 600px!important;*/
/*    }*/
/*}*/

/*@media (min-width: 992px) {*/
/*    .gc-login-container {*/
/*        width: 600px!important;*/
/*    }*/
/*}*/

/*@media (min-width: 571px) {*/
/*    .gc-login-container {*/
/*        width: 80vw!important;*/
/*    }*/
/*}*/

/*.gc-login-card,*/
/*.full-page-bg-color,*/
/*.gc-login-form {*/
/*    width: 80vw;*/
/*    max-width: 600px;*/
/*}*/

.gc-login-form {
    min-width: 300px;
    /*max-width: 600px;*/
    /*background: url(../../../assets/images/pages/login.png) no-repeat fixed;*/
    /*background-size: contain;*/
}

    .vx-card.no-bg {
        background: none;
        box-shadow: none;
        .full-page-bg-color {
            background: none;
        }
    }

.layout--full-page .bg-img {
    background-image: url(https://cdn-alioss-bj-open.intab.cn/static/pros/xurui/images/bg-trucks/bg-3.jpg);
}

.gc-login-container {
    width: 85%;
    .gc-login-form {
        max-width: 360px;
    }
}
.vs-con-input-label.is-label-placeholder {
    margin-top: 0px;
}
.mb-base {
    margin-bottom: 1.8rem !important;
}
</style>
